import React from "react"
import { Box } from "@carrotfertility/carotene-core"
import useInitialSetup from "#/components/cmd-enrollment/hooks/useInitialSetup"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineContext"
import { Steps } from "#/components/cmd-enrollment/workflow/steps"
import { useBenefitEnrollment } from "#/components/context/enrollment/BenefitEnrollmentContext"

function EmptySpace(): JSX.Element {
  // This is to prevent extra flashing of the modal.
  // We might want to look to make a more elegant solution for this in the future.
  // Holds the modal at the height the nested-padding version produced (4 x 8rem + 3rem).
  return <Box sx={{ blockSize: "35rem" }} />
}

export function PartnerShouldShowPlanCoverageDateStep(): JSX.Element {
  const { shouldCollectPartnersCoverageDates } = useBenefitEnrollment()
  const viewName = Steps.PARTNER_SHOULD_SHOW_COLLECT_PLAN_COVERAGE
  const { setNextStep } = useStateMachine(viewName, null)
  useInitialSetup(() => {
    setNextStep(viewName, shouldCollectPartnersCoverageDates)
  })
  return <EmptySpace />
}
